app.directive('lecturerGrade', ["LecturerService", "toastr", "ConfirmModal", "usSpinnerService", "$state",
    function (LecturerService, toastr, ConfirmModal, usSpinnerService, $state) {
    return {
        restrict: 'E',
        replace: true,
        templateUrl: _pb + 'components/lecturer-grade/lecturer-grade.html',
        scope: {
            student: '=',
            grade: '=',
            gradeOptions: '=',
            gradeDisabled: '=',
            gradeLocked: '=',
            gradeCursor: '=',
            gradeCursorRemove: '='
        },
        controller: ['$scope', function ($scope) {
          $scope.isAdmin = $state.current.name === "admin.activation-grades";
          $scope.onInputChange = function () {
            if (!$scope.grade.grade.relative || !$scope.grade.grade.relative.trim()) {
              return $scope.gradeCursorRemove();
            }
            return $scope.gradeCursor($scope.grade);
          };

          $scope.lock = function (grade, $event) {
              if ($event) {
                  $event.preventDefault();
                  $event.stopPropagation();
              }
              ConfirmModal.show({
                  title: "ყურადღება",
                  message: "გსურთ შეფასების დაბლოკვა ?"
              }).result.then(function () {
                  usSpinnerService.spin("root");
                  LecturerService.blockGrade({subjectSelection: $scope.grade.selection, gradeComponent: grade._id}).then(function (result) {
                      if (result) {
                          toastr.success('შეფასება დაბლოკილია');
                          $scope.grade.grade = result;
                          usSpinnerService.stop("root");
                      }
                  }).catch(function (reason) {
                      toastr.warning(reason.data);
                      usSpinnerService.stop("root");
                  })
              });
          }

          $scope.unlock = function (grade, $event) {
              if ($event) {
                  $event.preventDefault();
                  $event.stopPropagation();
              }
              ConfirmModal.show({
                  title: "ყურადღება",
                  message: "გსურთ შეფასების განბლოკვა ?"
              }).result.then(function () {
                  usSpinnerService.spin("root");
                  LecturerService.unblockGrade({subjectSelection: $scope.grade.selection, gradeComponent: grade.grade._id}).then(function (result) {
                      if (result) {
                          toastr.success('შეფასება განბლოკილია');
                          $scope.grade.grade = {};
                          usSpinnerService.stop("root");
                      }
                  }).catch(function (reason) {
                      toastr.warning(reason.data);
                      usSpinnerService.stop("root");
                  })
              });
          }
        }]
    };
}]);
